import ApiAcces from "@/shared/services/ApiAcces";
import type IDashboardService from "../contracts/IDashboardService";
import type { Dashboard, DashboardUpsert } from "../models/Dashboard";
import type {
  DashboardDataRequest,
  DashboardDataResponse,
} from "../models/WidgetData";

export default class DashboardService
  extends ApiAcces
  implements IDashboardService
{
  async get(workspaceId: string): Promise<Dashboard | null> {
    try {
      return (await this.api.get(`api/workspaces/${workspaceId}/dashboard`)).data;
    } catch (err) {
      if ((err as { status?: number })?.status === 404) return null;
      throw err;
    }
  }

  async upsert(
    workspaceId: string,
    dashboard: DashboardUpsert,
  ): Promise<Dashboard> {
    return (
      await this.api.put(`api/workspaces/${workspaceId}/dashboard`, dashboard)
    ).data;
  }

  async delete(workspaceId: string): Promise<void> {
    await this.api.delete(`api/workspaces/${workspaceId}/dashboard`);
  }

  async getData(
    workspaceId: string,
    request: DashboardDataRequest = {},
  ): Promise<DashboardDataResponse> {
    return (
      await this.api.post(`api/workspaces/${workspaceId}/dashboard/data`, request)
    ).data;
  }
}
